import { createSlice } from '@reduxjs/toolkit';

// Create the slice
const AuthenticatedUserSlice = createSlice({
  name: 'AuthenticatedUser',
  initialState: '',
  reducers: {
    setAuthenticatedUser: (state, action) => {
      return action.payload;
    }
  },
});

export const { setAuthenticatedUser} = AuthenticatedUserSlice.actions;

export default AuthenticatedUserSlice.reducer;